/**
 * The Tailwind palette, as data.
 *
 * <p>WHY THIS FILE EXISTS RATHER THAN var( --color-red-500 ). Tailwind 4 emits
 * a custom property only for a colour something actually uses, and this app
 * uses a handful: a grep of the built bundle finds THREE `--color-*-500`
 * variables. A picker that offered only what the stylesheet happened to need
 * would offer three columns, and one that asked for all 242 would have to
 * introduce a rule per colour to force them out -- 242 dead rules shipped to
 * every visitor so that an admin can look at swatches.
 *
 * So the palette is carried here, as the hex values Tailwind's own ramps use.
 * It is 22 families of 11 steps, which is what tailwindcolor.com shows, and it
 * is the same set whatever the build decided to emit.
 *
 * <p><b>GENERATED FROM node_modules/tailwindcss/theme.css, not from memory.</b>
 * The first draft of this file was typed out and was the v3 palette, which v4
 * replaced: v3's green-700 is #15803d and v4's is #008236, and every ramp moved
 * like that when the palette went to oklch. A picker offering last year's
 * colours under this year's names would be worse than no picker. The values
 * below are that file's own oklch, run through {@link esHexOf}.
 *
 * <p>To regenerate after a Tailwind upgrade, read every {@code --color-<family>-<step>}
 * out of theme.css and convert it the same way.
 */

export const ES_SHADES = [ 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950 ];

export const ES_PALETTE = {
    slate:   [ '#f8fafc','#f1f5f9','#e2e8f0','#cad5e2','#90a1b9','#62748e','#45556c','#314158','#1d293d','#0f172b','#020618' ],
    gray:    [ '#f9fafb','#f3f4f6','#e5e7eb','#d1d5dc','#99a1af','#6a7282','#4a5565','#364153','#1e2939','#101828','#030712' ],
    zinc:    [ '#fafafa','#f4f4f5','#e4e4e7','#d4d4d8','#9f9fa9','#71717b','#52525c','#3f3f46','#27272a','#18181b','#09090b' ],
    neutral: [ '#fafafa','#f5f5f5','#e5e5e5','#d4d4d4','#a1a1a1','#737373','#525252','#404040','#262626','#171717','#0a0a0a' ],
    stone:   [ '#fafaf9','#f5f5f4','#e7e5e4','#d6d3d1','#a6a09b','#79716b','#57534d','#44403b','#292524','#1c1917','#0c0a09' ],
    red:     [ '#fef2f2','#ffe2e2','#ffc9c9','#ffa2a2','#ff6467','#fb2c36','#e7000b','#c10007','#9f0712','#82181a','#460809' ],
    orange:  [ '#fff7ed','#ffedd4','#ffd6a7','#ffb86a','#ff8904','#ff6900','#f54900','#ca3500','#9f2d00','#7e2a0c','#441306' ],
    amber:   [ '#fffbeb','#fef3c6','#fee685','#ffd230','#ffb900','#fe9a00','#e17100','#bb4d00','#973c00','#7b3306','#461901' ],
    yellow:  [ '#fefce8','#fef9c2','#fff085','#ffdf20','#fdc700','#f0b100','#d08700','#a65f00','#894b00','#733e0a','#432004' ],
    lime:    [ '#f7fee7','#ecfcca','#d8f999','#bbf451','#9ae600','#7ccf00','#5ea500','#497d00','#3c6300','#35530e','#192e03' ],
    green:   [ '#f0fdf4','#dcfce7','#b9f8cf','#7bf1a8','#05df72','#00c950','#00a63e','#008236','#016630','#0d542b','#032e15' ],
    emerald: [ '#ecfdf5','#d0fae5','#a4f4cf','#5ee9b5','#00d492','#00bc7d','#009966','#007a55','#006045','#004f3b','#002c22' ],
    teal:    [ '#f0fdfa','#cbfbf1','#96f7e4','#46ecd5','#00d5be','#00bba7','#009689','#00786f','#005f5a','#0b4f4a','#022f2e' ],
    cyan:    [ '#ecfeff','#cefafe','#a2f4fd','#53eafd','#00d3f2','#00b8db','#0092b8','#007595','#005f78','#104e64','#053345' ],
    sky:     [ '#f0f9ff','#dff2fe','#b8e6fe','#74d4ff','#00bcff','#00a6f4','#0084d1','#0069a8','#00598a','#024a70','#052f4a' ],
    blue:    [ '#eff6ff','#dbeafe','#bedbff','#8ec5ff','#51a2ff','#2b7fff','#155dfc','#1447e6','#193cb8','#1c398e','#162456' ],
    indigo:  [ '#eef2ff','#e0e7ff','#c6d2ff','#a3b3ff','#7c86ff','#615fff','#4f39f6','#432dd7','#372aac','#312c85','#1e1a4d' ],
    violet:  [ '#f5f3ff','#ede9fe','#ddd6ff','#c4b4ff','#a684ff','#8e51ff','#7f22fe','#7008e7','#5d0ec0','#4d179a','#2f0d68' ],
    purple:  [ '#faf5ff','#f3e8ff','#e9d4ff','#dab2ff','#c27aff','#ad46ff','#9810fa','#8200db','#6e11b0','#59168b','#3c0366' ],
    fuchsia: [ '#fdf4ff','#fae8ff','#f6cfff','#f4a8ff','#ed6aff','#e12afb','#c800de','#a800b7','#8a0194','#721378','#4b004f' ],
    pink:    [ '#fdf2f8','#fce7f3','#fccee8','#fda5d5','#fb64b6','#f6339a','#e60076','#c6005c','#a3004c','#861043','#510424' ],
    rose:    [ '#fff1f2','#ffe4e6','#ffccd3','#ffa1ad','#ff637e','#ff2056','#ec003f','#c70036','#a50036','#8b0836','#4d0218' ],
};

export const ES_FAMILIES = Object.keys( ES_PALETTE );

/** "red-500" for a hex, or null when nothing in the ramps is that colour. */
export const esColorName = ( pHex ) => {
    if ( !pHex ) return null;

    const aHex = pHex.toLowerCase();
    for ( const aFamily of ES_FAMILIES ) {
        const aAt = ES_PALETTE[ aFamily ].indexOf( aHex );
        if ( aAt >= 0 ) return aFamily + '-' + ES_SHADES[ aAt ];
    }
    return null;
};

/**
 * A computed CSS colour as a hex string.
 *
 * <p><b>oklch is the case that matters.</b> Tailwind 4's ramps are declared in
 * oklch, and {@code getComputedStyle} hands back what was declared -- so a band
 * painted by {@code bg-green-700} reads as {@code oklch(0.627 0.194 149.214)}
 * and not as anything this file can look up. Converting is the only way to
 * answer "what colour is that, in the names a stylesheet uses" for a colour
 * nobody typed as hex.
 *
 * <p>The maths is Björn Ottosson's: oklch to oklab by polar coordinates, oklab
 * to LMS, LMS to linear sRGB, then the sRGB transfer function. rgb() is handled
 * too, because a browser that resolved something to rgb should not be a hole,
 * and a hex passes straight through.
 *
 * @return a lower-case #rrggbb, or null for a value this cannot read
 */
export const esHexOf = ( pColor ) => {
    if ( !pColor ) return null;

    const aText = String( pColor ).trim().toLowerCase();
    if ( aText.startsWith( '#' ) ) return aText.length === 4
        ? '#' + [ ...aText.slice( 1 ) ].map( ( pIt ) => pIt + pIt ).join( '' )
        : aText;

    const aByte = ( pIt ) => Math.max( 0, Math.min( 255, Math.round( pIt ) ) )
        .toString( 16 ).padStart( 2, '0' );

    const aRgb = aText.match( /^rgba?\(([^)]+)\)/ );
    if ( aRgb ) {
        const aParts = aRgb[ 1 ].split( /[\s,/]+/ ).filter( Boolean ).slice( 0, 3 ).map( Number );
        if ( aParts.length < 3 || aParts.some( Number.isNaN ) ) return null;
        return '#' + aParts.map( aByte ).join( '' );
    }

    const aOklch = aText.match( /^oklch\(([^)]+)\)/ );
    if ( !aOklch ) return null;

    const aParts = aOklch[ 1 ].split( /[\s,/]+/ ).filter( Boolean );
    // L may be a percentage; C and H are plain numbers.
    const aL = aParts[ 0 ].endsWith( '%' ) ? parseFloat( aParts[ 0 ] ) / 100 : parseFloat( aParts[ 0 ] );
    const aC = parseFloat( aParts[ 1 ] );
    const aH = ( parseFloat( aParts[ 2 ] ) || 0 ) * Math.PI / 180;
    if ( Number.isNaN( aL ) || Number.isNaN( aC ) ) return null;

    const aA = aC * Math.cos( aH );
    const aB = aC * Math.sin( aH );

    const aLms = ( pL, pM, pS ) => [ pL * pL * pL, pM * pM * pM, pS * pS * pS ];
    const [ l, m, s ] = aLms(
        aL + 0.3963377774 * aA + 0.2158037573 * aB,
        aL - 0.1055613458 * aA - 0.0638541728 * aB,
        aL - 0.0894841775 * aA - 1.2914855480 * aB );

    // Linear sRGB, then the transfer function. Out-of-gamut values are clamped
    // by aByte rather than gamut-mapped: this is for naming a colour that is
    // already on screen, so it is in gamut by construction.
    const aGamma = ( pIt ) => pIt <= 0.0031308
        ? 12.92 * pIt
        : 1.055 * Math.pow( Math.max( pIt, 0 ), 1 / 2.4 ) - 0.055;

    return '#' + [
        aGamma(  4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s ),
        aGamma( -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s ),
        aGamma( -0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s ),
    ].map( ( pIt ) => aByte( pIt * 255 ) ).join( '' );
};

/**
 * The Tailwind name for a colour, exactly when it is one and otherwise the
 * closest one there is.
 *
 * <p>Never a hex and never an rgb triple: the point of the name is that it can
 * be typed into a stylesheet, and "#0a7f98" cannot. Three of this app's own
 * bands are hand-mixed values that sit between two steps of a ramp -- a dark
 * yellow that Tailwind's own ramp turns brown at, and two blues between 600 and
 * 700 -- and for those the nearest name is the useful answer rather than no
 * answer.
 *
 * <p>Distance is plain Euclidean in sRGB. It is not a perceptual metric and
 * does not need to be: the ramps are far enough apart that the nearest one is
 * unambiguous for any colour picked out of them or mixed between two of them.
 */
export const esNearestColorName = ( pHex ) => {
    const aExact = esColorName( pHex );
    if ( aExact ) return aExact;
    if ( !pHex || !/^#[0-9a-f]{6}$/i.test( pHex ) ) return null;

    const aOf = ( pIt ) => [ 1, 3, 5 ].map( ( pAt ) => parseInt( pIt.slice( pAt, pAt + 2 ), 16 ) );
    const [ r, g, b ] = aOf( pHex.toLowerCase() );

    let aBest = null;
    let aLeast = Infinity;
    for ( const aFamily of ES_FAMILIES ) {
        ES_PALETTE[ aFamily ].forEach( ( pRamp, pAt ) => {
            const [ rr, gg, bb ] = aOf( pRamp );
            const aGap = ( r - rr ) ** 2 + ( g - gg ) ** 2 + ( b - bb ) ** 2;
            if ( aGap < aLeast ) {
                aLeast = aGap;
                aBest = aFamily + '-' + ES_SHADES[ pAt ];
            }
        } );
    }
    return aBest;
};
